export const a11yProps = (index, id) => ({
  id: id || `full-width-tab-${index}`,
  "aria-controls": id
    ? `full-width-tabpanel-${id}`
    : `full-width-tabpanel-${index}`,
});
